import SearchBox from "./component/SearchBox";
import TableBox from "./component/TableBox";
import FormItem from './components/FormItem/FormItem'
import ButtonBox from "./component/BottonBox";
import FormBox from "./component/FormBox"
import TabsBox from "./component/TabsBox"
import UploadImg from "./components/UploadImg/UploadImg";
import UploadImgs from "./components/UploadImgs/UploadImgs";
import DoubleUploadImg from "./components/DoubleUploadImg/DoubleUploadImg"
export default {
  SearchBox,
  TableBox,
  ButtonBox,
  FormItem,
  FormBox,
  TabsBox,
  UploadImg,
  UploadImgs,
  DoubleUploadImg,
}